import {tns} from "tiny-slider";

export function reviewsSlider() {

    let slider      = '.js-reviews';

    if(document.querySelector(slider)) {
        let sliderElement = tns({
            container: slider,
            controls: false,
            nav: true,
            navPosition: 'bottom',
            mouseDrag: true,
            gutter: 60,
            loop: false
        })
    }

    return 'reviewsSlider';
}
